import { AbstractFilter } from './abstractFilter';

export class DefaultFilter extends AbstractFilter {
  getDisplayName(filterValue) {
    if (typeof filterValue !== 'object') return filterValue || '';
    const { value, displayName } = filterValue || {};
    return value || displayName || '';
  }
}
